import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { priceFixed_value, DISPOSITIONNEW, RESIZE, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import {
  getValueOrDefaultObject,
  getFullImagePath,
  getPrice,
  isEmptyEvery,
  isMobileDevice,
  getPDPurl,
  getMainImagePath,
  getBackgroundImageSrc,
  getBackgroundImagePath,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import ImageComponent from 'atoms/Image';
import ModalComponent from 'molecules/Modal';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { computeSurgePrice } from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';

const { CHOOSE_ANY_PRODUCT } = TRANSLATE_MAPPING_KEY;
const getPromoAvailability = availability => {
  return availability?.map(ele => ({
    ...ele,
    price: ele?.promoPrice && ele?.promoPrice < ele?.price ? ele?.promoPrice : ele?.price,
  }));
};
export const MultiProductPromoModal = props => {
  const { PLP_PDP_DETAILS, SET_MULTI_PRODUCT_VIEW_MODAL } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const storesReducer = useSelector(data => data.storesReducer);
  const flatResponse = useSelector(({ menuReducer: { flatResponse = {} } = {} }) => flatResponse || {});
  const {
    isDealModalOpen: isProductModalOpen,
    handleClose,
    viewProductCardData,
    imageContainerSize,
  } = getValueOrDefaultObject(props);
  const { item, titleValue, promoParams, priceDetails } = getValueOrDefaultObject(viewProductCardData);
  const { itemDetails } = getValueOrDefaultObject(item);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { data: { categories = [] } = {} } = useSelector(({ menuReducer }) => menuReducer || {});
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const storeTimeZone =
    storesReducer?.storesWithStatus?.length && storesReducer?.storesWithStatus[0]?.summary?.timeZoneIANA;
  const modalProps = {
    id: 'productDetailsPopUp',
    role: 'dialog',
    modalTitleId: 'productDetailsPopUp',
    show: { isProductModalOpen },
    classNames: 'multi-product-wrapper-modal',
    showCloseBtn: true,
    closeButtonHandler: handleClose,
    modalTitle: titleValue,
    autoFocus: true,
  };
  const { headerData: { plpBackgroundImage = {} } = {} } = useSelector(state =>
    getValueOrDefaultObject(state?.marketConfigReducer?.response),
  );
  const plpbackgroundImageData = getBackgroundImagePath(plpBackgroundImage);
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(DISPOSITIONNEW))
    : userOrderState.dispositionNew;
  /* istanbul ignore next */
  const params = useMemo(() => {
    return {
      storeInfo: dispositionNew ? dispositionNew.store : {},
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispositionNew, userOrderState, tenantReducer]);

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  /**
   * useEffect to add and cleanup of window resize event
   */
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
    return () => {
      window.removeEventListener(RESIZE, windowResized);
    };
  });

  const onCardClickHandler = (
    productId,
    customizable,
    categoryId,
    productInfo,
    catalogs,
    category_url,
    id,
    categoryName,
  ) => {
    let ProductDetails = {
      productId,
      customizable,
      categoryId,
      catalogName: catalogs,
      productInfo: productInfo,
      isFromPlp: true,
      categoryName: categoryName,
      categoryUrl: category_url,
    };

    const { url: prod_url } = flatResponse?.productMapByItemId?.[id] ?? {};

    userOrderStateDispatch({
      type: PLP_PDP_DETAILS,
      value: ProductDetails,
    });
    userOrderStateDispatch({
      type: SET_MULTI_PRODUCT_VIEW_MODAL,
      isFromMultiProductViewModal: true,
    });
    localStorage.setItem(LOCAL_STORAGE_KEYS.PRODUCT_DETAILS, JSON.stringify(ProductDetails));
    props?.history?.push({
      pathname: getPDPurl(category_url, prod_url, props?.history?.location?.pathname),
    });
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.VIEW_PRODUCT,
      JSON.stringify({
        couponCode: item?.couponCode,
        promoParams: promoParams,
        priceDetails,
      }),
    );
    userOrderStateDispatch({ type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PROMO_MODE, value: { pdpPromoPage: true } });
  };

  const CardTemplate = ({ item, params }) => {
    const {
      dname = [],
      imageName,
      content,
      availability = [],
      customizable,
      id,
      categoryUrl,
    } = getValueOrDefaultObject(item);
    const surgePriceObj = computeSurgePrice(availability, storeTimeZone);
    const { caloricValue } = getValueOrDefaultObject(content);
    const calories = caloricValue;
    const { storeInfo } = getValueOrDefaultObject(params);

    let categoryUrlName = categoryUrl && categoryUrl[0];
    categoryUrlName = categoryUrlName?.split('-').join(' ')?.toUpperCase();

    let categoryItem = categories?.filter(itemVal => itemVal?.name?.toUpperCase() === categoryUrlName);
    const categoryItemId = categoryItem && categoryItem[0];
    const categoryName = categoryItemId?.name;
    const productId = id, //'I-32226'
      categoryId = categoryItemId?.id, //'C-20035'
      productInfo = {
        productName: dname,
        productImage: imageName,
        productPrice: getPrice(surgePriceObj, tenantReducer?.currencyConversionFactor, storeTimeZone),
      };
    const catalogs =
      (storeInfo && storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
      tenantReducer?.genericMenuName ||
      '';

    const promoAvailability = getPromoAvailability(availability);
    const mpmSurgePriceObj = computeSurgePrice(promoAvailability, storeTimeZone);
    const plpBackgroundStyle = () =>
      getBackgroundImageSrc(plpbackgroundImageData, imageContainerSize, imageContainerSize);
    return (
      <div
        class='container'
        data-testid='container-test'
        onClick={() =>
          onCardClickHandler(productId, customizable, categoryId, productInfo, catalogs, categoryUrl, id, categoryName)
        }
      >
        <main class='grid'>
          <article>
            <div className='product-image-parent-container' style={plpBackgroundStyle()}>
              <ImageComponent
                data-testid='multi-product-image'
                className='multi-product-image'
                defaultPath={getFullImagePath(null, tenantReducer, true)}
                srcFile={getMainImagePath(content, imageContainerSize, imageContainerSize)}
                alt=''
              />
            </div>
            <div class='description-txt'>
              <span className='desc'>{dname[0]?.value}</span>
              <span className='price-value'>
                {tenantReducer?.currencySymbol}
                {getPrice(mpmSurgePriceObj, tenantReducer?.currencyConversionFactor, storeTimeZone).toFixed(
                  priceFixed_value,
                )}
              </span>
              <span>{calories && <span className='kj-info'>{` ${calories} ${tenantReducer?.kilojoule}`}</span>}</span>
            </div>
          </article>
        </main>
      </div>
    );
  };

  const redirectToPdp = itemData => {
    const { storeInfo, tenantReducer } = params;
    const { imageName, dname, availability, customizable, id, categoryUrl } =
      (itemData?.itemDetails?.length && itemData?.itemDetails[0]) ?? {};
    let categoryUrlName = categoryUrl && categoryUrl[0];
    categoryUrlName = categoryUrlName?.split('-').join(' ')?.toUpperCase();
    const surgePriceObj = computeSurgePrice(availability, storeTimeZone);
    let categoryItem = categories?.filter(itemVal => itemVal?.name?.toUpperCase() === categoryUrlName);
    const categoryItemId = categoryItem && categoryItem[0];
    const categoryName = categoryItemId?.name;
    const productId = id, //'I-32226'
      categoryId = categoryItemId?.id, //'C-20035'
      productInfo = {
        productName: dname,
        productImage: imageName,
        productPrice: getPrice(surgePriceObj, tenantReducer?.currencyConversionFactor, storeTimeZone),
      };
    const catalogName =
      (storeInfo && storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
      tenantReducer?.genericMenuName ||
      '';
    onCardClickHandler(productId, customizable, categoryId, productInfo, catalogName, categoryUrl, id, categoryName);
  };

  return (
    <React.Fragment>
      {itemDetails && itemDetails?.length > 1 && (
        <ModalComponent {...modalProps} data-testid='offers-deals-modal-testid'>
          <div className='multi-product-wrapper'>
            <div className='content'>
              <h4>{translateWithI18Next(CHOOSE_ANY_PRODUCT)}</h4>
            </div>
            <div className='grid-container card-items container'>
              {itemDetails?.map(itemVal => {
                return <CardTemplate item={itemVal} params={params} />;
              })}
            </div>
          </div>
        </ModalComponent>
      )}
      {itemDetails && itemDetails?.length === 1 && redirectToPdp(item)}
    </React.Fragment>
  );
};

export default MultiProductPromoModal;
